import { render, staticRenderFns } from "./IngresosEgresos.vue?vue&type=template&id=4bce2c64&scoped=true"
import script from "./IngresosEgresos.vue?vue&type=script&lang=js"
export * from "./IngresosEgresos.vue?vue&type=script&lang=js"
import style0 from "./IngresosEgresos.vue?vue&type=style&index=0&id=4bce2c64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bce2c64",
  null
  
)

export default component.exports